export default __webpack_public_path__ + "aaa75b7203abfefc194832e4241f02f4.svg";